module.exports = __webpack_public_path__ + "media/images/components/landing_pages/reassurance_cards/accessible@3x-38d139dca80f8b73c2ea3688e8b096d9.png";